import React, { Component } from "react";
import "../../../styles/commoncomponents/toggleSelector.scss";
class TruckSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnAction: true,
    };
  }
  componentDidMount() {}

  handleAction = () => {
    this.setState({ btnAction: !this.state.btnAction });
    this.props.onParentCall(!this.state.btnAction, this.props.id);
  };

  render() {
    return (
		<div className="truck-container">
			<div className="truck-btn">
				{/* <button onClick={this.handleAction}>
            {this.state.btnAction ? "ON" : "OFF"}
          </button> */}
				<label className="switch">
					<input
						type="checkbox"
						checked={this.state.btnAction}
						onChange={this.handleAction}
						id="togBtn"
					/>
					<div className="slider round"></div>
				</label>
			</div>
			<div className="truck-name">
				<i
					className="fa fa-truck"
					style={{ color: this.props.colour, fontSize: "23px" }}
				/>
				<span>{this.props.name}</span>
			</div>
		</div>
	);
  }
}

export default TruckSelect;
